import React from 'react';
import { Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMediaPredicate } from 'react-media-hook';
import { ERoutesCommon, ERoutesPrivate } from 'common/models/routesModel';
import { formatAmount } from 'common/helpers/format.helper';
import { MEDIA_MOBILE } from 'common/config/base.config';
import { ReactComponent as SvgShopBag } from 'app/assets/images/shopBag.svg';
import { useAppSelector } from 'app/store/store.hooks';

export const ShopBag: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cartModel, cartModelLoading } = useAppSelector((state) => state.cart);
  const { total, items, discountTotal } = cartModel || {};
  const finalTotal = formatAmount(discountTotal || total || 0);

  const hasCart = items?.length;
  const showCartBtn = location.pathname.includes(ERoutesCommon.Main);
  const isMobile: boolean = useMediaPredicate(MEDIA_MOBILE);

  if (!showCartBtn) {
    return null;
  }

  if (!hasCart && !cartModelLoading) {
    return null;
  }

  return (
    <div className={`cart-btn__wrapper ${isMobile && 'cart-btn__wrapper_mobile'}`}>
      <Button
        className="btn-opacity btn-opacity_orange d-flex-inline cart-btn__btn"
        onClick={() => {
          navigate(ERoutesPrivate.Bag);
        }}
        loading={cartModelLoading}
      >
        <SvgShopBag className="mr-4" />
        <span className="fs-sm">
          <span className="font-weight-7">Your bag</span> (P
          <span className="font-weight-7">{finalTotal})</span>
        </span>
      </Button>
    </div>
  );
};
